import { render, staticRenderFns } from "./logistics.vue?vue&type=template&id=14eb24ed&scoped=true&"
import script from "./logistics.vue?vue&type=script&lang=js&"
export * from "./logistics.vue?vue&type=script&lang=js&"
import style0 from "./logistics.vue?vue&type=style&index=0&id=14eb24ed&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14eb24ed",
  null
  
)

export default component.exports